import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import { TextField, Button, Stack, MenuItem } from "@mui/material";

export default function ReportFilterBar({
  filters,
  values,
  onChange,
  onFetch
}) {

  const [users, setUsers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [workItems, setWorkItems] = useState([]);

  const handleChange = (field, value) => {
    onChange({
      ...values,
      [field]: value
    });
  };

  useEffect(() => {
    loadUsers();
    loadProjects();
  }, []);

  useEffect(() => {
    if (values.project) {
      loadWorkItems(values.project);
    }
  }, [values.project]);



  const loadUsers = async () => {
    try {

      const res = await api.get("/api/users");

      let list = [];

      if (Array.isArray(res.data)) {
        list = res.data;
      } else if (Array.isArray(res.data.rows)) {
        list = res.data.rows;
      } else if (Array.isArray(res.data.data)) {
        list = res.data.data;
      }

      setUsers(list);

    } catch (err) {

      console.error("User fetch failed:", err);
      setUsers([]);

    }
  };



  const loadProjects = async () => {
    try {

      const res = await api.get("/api/projects");

      let list = [];

      if (Array.isArray(res.data)) {
        list = res.data;
      } else if (Array.isArray(res.data.rows)) {
        list = res.data.rows;
      } else if (Array.isArray(res.data.data)) {
        list = res.data.data;
      }

      setProjects(list);

    } catch (err) {

      console.error("Project fetch failed:", err);
      setProjects([]);

    }
  };



  const loadWorkItems = async (projectId) => {
    try {

      const res = await api.get("/api/work-items", {
        params: { project: projectId }
      });

      let list = [];

      if (Array.isArray(res.data)) {
        list = res.data;
      } else if (Array.isArray(res.data.rows)) {
        list = res.data.rows;
      } else if (Array.isArray(res.data.data)) {
        list = res.data.data;
      }

      setWorkItems(list);

    } catch (err) {

      console.error("Work item fetch failed:", err);
      setWorkItems([]);

    }
  };



  return (
    <Stack direction="row" spacing={2} sx={{ marginTop: 2 }}>

      {/* Start Date */}
      {filters.includes("startDate") && (
        <TextField
          label="Start Date"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={values.startDate || ""}
          onChange={(e) => handleChange("startDate", e.target.value)}
        />
      )}

      {/* End Date */}
      {filters.includes("endDate") && (
        <TextField
          label="End Date"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={values.endDate || ""}
          onChange={(e) => handleChange("endDate", e.target.value)}
        />
      )}

      {/* User */}
      {filters.includes("user") && (
        <TextField
          select
          label="User"
          value={values.user || ""}
          onChange={(e) => handleChange("user", e.target.value)}
          sx={{ minWidth: 200 }}
        >
          <MenuItem value="">All</MenuItem>

          {users.map((u) => (
            <MenuItem key={u.id} value={u.id}>
              {u.name || u.username || u.email}
            </MenuItem>
          ))}

        </TextField>
      )}

      {/* Project */}
      {filters.includes("project") && (
        <TextField
          select
          label="Project"
          value={values.project || ""}
          onChange={(e) => handleChange("project", e.target.value)}
          sx={{ minWidth: 200 }}
        >
          <MenuItem value="">All</MenuItem>

          {projects.map((p) => (
            <MenuItem key={p.id} value={p.id}>
              {p.name}
            </MenuItem>
          ))}

        </TextField>
      )}

      {/* Work Item */}
      {filters.includes("workItem") && (
        <TextField
          select
          label="Work Item"
          value={values.workItem || ""}
          onChange={(e) => handleChange("workItem", e.target.value)}
          sx={{ minWidth: 200 }}
        >
          <MenuItem value="">All</MenuItem>

          {workItems.map((w) => (
            <MenuItem key={w.id} value={w.id}>
              {w.title}
            </MenuItem>
          ))}

        </TextField>
      )}

      {/* Fetch Button */}
      <Button
        variant="contained"
        onClick={onFetch}
      >
        Fetch
      </Button>

    </Stack>
  );
}